export const reference_dates = {
    one_week: "1 semaine",
    fifteen_days: "2 semaines",
    one_month: "1 mois",
    two_months: "2 mois",
    more_than_two_months: "plus de 3 mois",

}